<template>
  <div>
      {{$t('Permiso Denegado')}}
  </div>
</template>

<script>
export default {
  name: 'PermissionDenied',
};
</script>
